import React from "react";
import { ContextMenu, Menu, MenuItem } from "@focus/focusUI";
export const showContextMenu = (listVariables, accessLevelConfig) => (e) => {
    if (e.target.lastChild === null ||
        (e.target.lastChild.localName !== "div" &&
            e.target.lastChild.localName !== "span"))
        return;
    e.preventDefault();
    ContextMenu.show(React.createElement(Menu, null,
        React.createElement(MenuItem, { icon: "list", text: "List variables", onClick: listVariables }),
        accessLevelConfig.accessData && (React.createElement(MenuItem, { icon: "list", text: "Access levels", onClick: () => accessLevelConfig.showAccessList(true) }))), { left: e.clientX, top: e.clientY }, () => { });
};
//# sourceMappingURL=ContextMenu.js.map